import { render, staticRenderFns } from "./addEmail.vue?vue&type=template&id=c10b4542&"
import script from "./addEmail.vue?vue&type=script&lang=js&"
export * from "./addEmail.vue?vue&type=script&lang=js&"
import style0 from "./addEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports